import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AssessmentResult, User } from './../model/model';

@Injectable()
export class AssessmentResultService {
  public queryEndPointAssignment = 'query-api/Assignment';
  public playerCommandEndPoint = 'command-api/QtiPlayer';

  constructor(private http: HttpClient) { }

  getResults = (assignmentId: string): Observable<AssessmentResult[]> =>
    this.http.get<AssessmentResult[]>(`${this.queryEndPointAssignment}/${assignmentId}/assessmentresults`)

  getUserByAssignment = (assignmentId: string): Observable<User> =>
    this.http.get<User>(`${this.queryEndPointAssignment}/${assignmentId}/candidate`)

  reviewItem = (sessionId: string, itemRefId: string): Observable<string> =>
    this.http.post(`${this.playerCommandEndPoint}/ReviewItem`, { sessionId: sessionId, itemRefId: itemRefId },
      { responseType: 'text' })

}
